import { render, staticRenderFns } from "./SelectSeatMiddlePage.vue?vue&type=template&id=39b8f5cc&"
import script from "./SelectSeatMiddlePage.vue?vue&type=script&lang=ts&"
export * from "./SelectSeatMiddlePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports